/**
 * @prettier
 */

function KioskQueuesWS(parent, locationId) {
  var self = this;

  AbstractWS.apply(self, arguments);

  self.name = "KioskLocationQueuesWS";

  self.serviceURL = ko.computed(self.generateUrl, self, { deferEvaluation: true });
  self.locationId = ko.observable(locationId);

  /**
   * Contains the Kiosk Resource Selection Configuration indexed by Location
   * then by Queue.
   */
  self.locationConfigurations = {};

  /**
   * Expose locationConfigurations as a Knockout Observable.
   */
  self.resourceSelectionConfigurations = ko.observable();

  /**
   * Loops over returned data and set the properties -
   * corresponding employee QueueModels, already in memory
   *
   * @method processData
   * @param {XMLDocument} data
   * @returns none
   */
  self.processData = function (data) {
    AbstractWS.prototype.processData.call(self, data);

    var json = xmlToJson.parse(data);
    if (json && json.queues && json.queues.queue) {
      var queues = Array.isArray(json.queues.queue) ? json.queues.queue : [json.queues.queue];
      // Do not store the whole Queue Kiosk configuration, 
      // Calendar only wants Resource configuration.
      this.locationConfigurations = self.resourceSelectionConfigurationsForQueues(queues);
    }
  };

  return self;
}

KioskQueuesWS.prototype = Object.create(AbstractWS.prototype);
KioskQueuesWS.prototype.constructor = KioskQueuesWS;

/**
 * Create URL
 *
 * @returns
 */
KioskQueuesWS.prototype.generateUrl = function () {
  var locationId = this.locationId();
  return "/qless/api/v1/kiosk/location/" + locationId + "/queues";
};

/**
 *
 * Extract the Resource Selection Configuration from the Queues' Kiosk Configuration (kioskInfo)
 *
 * @param {Array<{kioskInfo|appointmentsEnabled}>} queues
 * @returns
 */

KioskQueuesWS.prototype.resourceSelectionConfigurationsForQueues = function (queues) {
  return queues
    .filter(function (queueData) {
      return queueData.appointmentsEnabled && queueData.kioskInfo;
    })
    .reduce(function (resourceSelectionConfiguration, queueData) {
      if (
        typeof queueData.kioskInfo.forceResourceSelection !== "undefined" ||
        typeof queueData.kioskInfo.allowResourceSelection !== "undefined"
      ) {
        resourceSelectionConfiguration[queueData.id] = {
          allowResourceSelection: queueData.kioskInfo.allowResourceSelection,
          forceResourceSelection: queueData.kioskInfo.forceResourceSelection,
        };
      }

      return resourceSelectionConfiguration;
    }, {});
};

if (typeof exports !== "undefined") {
  exports.KioskQueuesWS = KioskQueuesWS;
}
